import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Row, Col } from "reactstrap";
import { Pie } from "react-chartjs-2";
import ReactTooltip from "react-tooltip";

class DeliveryChannels extends Component {
  render() {
    const { translate, channelsStats24h, channelsStats7d } = this.props;
    var labels = [];
    var values = [];
    var backgroundColor = [];
    var hoverBackgroundColor = [];
    channelsStats24h.forEach((item) => {
      labels.push(item.channelName);
      values.push(item.count);
      backgroundColor.push(item.colorHex);
      hoverBackgroundColor.push(item.colorHex);
    });

    var channelsStats24hChartData = {
      labels,
      datasets: [
        {
          data: values,
          backgroundColor,
          hoverBackgroundColor,
        },
      ],
    };
    labels = [];
    values = [];
    backgroundColor = [];
    hoverBackgroundColor = [];
    channelsStats7d.forEach((item) => {
      labels.push(item.channelName);
      values.push(item.count);
      backgroundColor.push(item.colorHex);
      hoverBackgroundColor.push(item.colorHex);
    });
    var channelsStats7dChartData = {
      labels,
      datasets: [
        {
          data: values,
          backgroundColor,
          hoverBackgroundColor,
        },
      ],
    };
    return (
      <Row className="delivery-states" style={{ marginTop: "2em" }}>
        <Col
          xs="6"
          className="files-sammary-column"
          style={{ padding: 0 }}
          onClick={this.navigateToFile}
        >
          <div className="panel panel-default">
            <div className="panel-heading">
              {translate("Delivery channels")}
            </div>
            <div className="type-header">{translate("24 hours")}</div>
            <div className="panel-body">
              <Row>
                <Col xs="7">
                  {channelsStats24h && channelsStats24h.length > 0 && (
                    <table style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th />
                          <th>{translate("Channel")}</th>
                          <th>{translate("Documents")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {channelsStats24h.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <div
                                className="circular-label"
                                style={{ backgroundColor: item.colorHex }}
                              />
                            </td>
                            <td>
                              {item.channelName}
                              {item.channelName &&
                                item.channelName.toLowerCase() === "ipost" && (
                                  <>
                                    <button
                                      className="tooltip-btn"
                                      data-tip
                                      data-place="bottom"
                                      data-type="info"
                                      data-effect="solid"
                                      data-for="activationTip-ipost"
                                    >
                                      <i
                                        className="fa fa-question-circle"
                                        style={{
                                          padding: "0px 7px 0px",
                                          fontSize: "0.8em",
                                        }}
                                      />
                                    </button>
                                    <ReactTooltip
                                      className="customeTheme"
                                      id="activationTip-ipost"
                                    >
                                      <div>
                                        <p>
                                          {translate("iPostServiceMessage")}
                                        </p>
                                      </div>
                                    </ReactTooltip>
                                  </>
                                )}{" "}
                            </td>
                            <td>{item.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </Col>
                <Col xs="5" style={{ padding: 0 }}>
                  <div className="pie-container">
                    <Pie
                      data={channelsStats24hChartData}
                      height={150}
                      options={{
                        maintainAspectRatio: false,
                        legend: {
                          display: false,
                        },
                        layout: { padding: 0 },
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col
          xs="6"
          className="docs-sammary-column"
          style={{ padding: 0 }}
          onClick={this.navigateToDocs}
        >
          <div className="panel panel-default">
            <div className="panel-heading" style={{ visibility: "hidden" }}>
              {translate("Delivery channels")}
            </div>
            <div
              className="type-header-docs"
              style={{ borderWidth: "2px 2px 2px 2px" }}
            >
              <span style={{ visibility: "visible" }}>
                {translate("7 days")}
              </span>
            </div>
            <div
              className="panel-body"
              style={{ borderWidth: "0 2px 2px 2px" }}
            >
              <Row>
                <Col xs="7">
                  {channelsStats7d && channelsStats7d.length > 0 && (
                    <table style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th />
                          <th>{translate("Channel")}</th>
                          <th>{translate("Documents")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {channelsStats7d.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <div
                                className="circular-label"
                                style={{ backgroundColor: item.colorHex }}
                              />
                            </td>
                            <td>
                              {item.channelName}
                              {item.channelName &&
                                item.channelName.toLowerCase() === "ipost" && (
                                  <>
                                    <button
                                      className="tooltip-btn"
                                      data-tip
                                      data-place="bottom"
                                      data-type="info"
                                      data-effect="solid"
                                      data-for="activationTip-ipost"
                                    >
                                      <i
                                        className="fa fa-question-circle"
                                        style={{
                                          padding: "0px 7px 0px",
                                          fontSize: "0.8em",
                                        }}
                                      />
                                    </button>
                                    <ReactTooltip
                                      className="customeTheme"
                                      id="activationTip-ipost"
                                    >
                                      <div>
                                        <p>
                                          {translate("iPostServiceMessage")}
                                        </p>
                                      </div>
                                    </ReactTooltip>
                                  </>
                                )}{" "}
                            </td>
                            <td>{item.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </Col>
                <Col xs="5" style={{ padding: 0 }}>
                  <div className="pie-container">
                    <Pie
                      data={channelsStats7dChartData}
                      height={150}
                      options={{
                        maintainAspectRatio: false,
                        legend: {
                          display: false,
                        },
                        layout: { padding: 0 },
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  const { homeSearch, authentication, locale } = state;
  const { subUser } = authentication;
  return {
    channelsStats24h: state.home.externalChannelsStats24h || [],
    channelsStats7d: state.home.externalChannelsStats7d || [],

    homeSearch,
    subUser,
    translate: getTranslate(locale),
  };
}

const connectedDeliveryChannels = connect(mapStateToProps)(DeliveryChannels);
export { connectedDeliveryChannels as DeliveryChannels };
